export default {
	getSelectedPosters: (state) => {
    return state.selectedPosters;
  },
	
	getTotalPosters: (state) => {
		return state.selectedPosters.length;
	},
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/store/print-posters/getters.js